
const Footer = () => {
    return(
        <article className=" mx-auto flex justify-center text-[.6rem] notebook:text-[.8rem] desktop:text-[1rem] full:text-[1.3rem] pt-[2.5rem] desktop:pt-[6rem]">
         <a href="https://github.com/mlabato/portfolio-mlabato" className="text-[#354F52] hover:text-[#84A98C] duration-300 text-center font-semibold">Designed & built by Martin Labato</a>   
        </article>
    )

}

export default Footer;